import { GameSettingType } from "@1games-ru/region-shared/dist/enums/account/settings";

export default function getTranslationSettingString(value: GameSettingType) {
  return `playerMenu.setting.${GameSettingType[value]}`;
}
